{
  "familyId": "SPR-WEET-DT",
  "questions": [
    {
      "id": "SPR-WEET-DT-001",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct? 'Hij ... het antwoord.'",
      "options": ["vindt", "vind", "vint", "vindd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Dt-woorden: stam + t", "content": "Bij 'hij/zij/het' in de tegenwoordige tijd: stam + t.\nVinden → stam = vind → hij vindt.\n\nDe stam eindigt al op -d, en je voegt -t toe → dt.\nDit is GEEN dt-fout, maar de gewone regel!", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_vindt_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Vinden → stam = vind. Bij 'hij': stam + t = vindt. De stam eindigt op -d, plus de -t van de persoonsvorm = -dt. Dit is correct!",
        "solutionSteps": ["Infinitief: vinden", "Stam: vind (d aan het einde)", "Hij + stam + t = hij vindt"],
        "distractorExplanations": {
          "0": "Goed! Hij vindt — stam 'vind' + t = vindt.",
          "1": "'Vind' is de stam, maar bij 'hij' moet je -t toevoegen: vindt.",
          "2": "'Vint' is fout: de stam is 'vind' (met d), niet 'vin'.",
          "3": "'Vindd' bestaat niet. Het is stam + t: vind + t = vindt."
        }
      }
    },
    {
      "id": "SPR-WEET-DT-002",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct? 'Het ... elke dag.'",
      "options": ["word", "wordt", "wort", "wordd"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Worden → wordt", "content": "Worden → stam = word. Bij 'het': stam + t = wordt.\n\nLet op: 'word' is de stam (ik word), 'wordt' is bij hij/zij/het.", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_wordt_basis",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Worden → stam = word. Bij 'het': stam + t = wordt. De -d van de stam plus de -t = -dt.",
        "solutionSteps": ["Infinitief: worden", "Stam: word", "Het + stam + t = het wordt"],
        "distractorExplanations": {
          "0": "'Word' is de stam (ik word), maar bij 'het' moet je -t toevoegen: wordt.",
          "1": "Goed! Het wordt — stam 'word' + t = wordt.",
          "2": "'Wort' is fout: de stam is 'word' (met d), niet 'wor'.",
          "3": "'Wordd' bestaat niet. Het is stam + t: word + t = wordt."
        }
      }
    },
    {
      "id": "SPR-WEET-DT-003",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "options": [
        "Zij houd van muziek.",
        "Zij hout van muziek.",
        "Zij houdt van muziek.",
        "Zij houdd van muziek."
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Houden → houdt", "content": "Houden → stam = houd. Bij 'zij' (enkelvoud): stam + t = houdt.\n\nDe d van de stam + t = dt. Dit is de gewone regel!", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_houdt_zin",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Houden → stam = houd. Bij 'zij' (enkelvoud): stam + t = houdt. Dus: 'Zij houdt van muziek.'",
        "solutionSteps": ["Infinitief: houden", "Stam: houd", "Zij + stam + t = zij houdt"],
        "distractorExplanations": {
          "0": "'Houd' is de stam (ik houd), maar bij 'zij' moet je -t toevoegen.",
          "1": "'Hout' is een zelfstandig naamwoord (materiaal), niet het werkwoord 'houden'.",
          "2": "Goed! Zij houdt — stam 'houd' + t = houdt.",
          "3": "'Houdd' bestaat niet. Het is stam + t: houd + t = houdt."
        }
      }
    },
    {
      "id": "SPR-WEET-DT-004",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "multiple_choice",
      "question": "Bij welk werkwoord krijg je GEEN -dt in de hij-vorm?",
      "options": ["vinden (hij vindt)", "worden (hij wordt)", "houden (hij houdt)", "lopen (hij loopt)"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Wanneer -dt?", "content": "Je krijgt -dt als de stam eindigt op -d:\nvinden → vind → vindt\nworden → word → wordt\nhouden → houd → houdt\n\nGeen -dt als de stam NIET op -d eindigt:\nlopen → loop → loopt (geen d in de stam)", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_herkennen_geen_dt",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Lopen → stam = loop. Bij 'hij': loop + t = loopt. Geen -dt, want de stam eindigt niet op -d. De andere drie (vind-t, word-t, houd-t) hebben wél -dt omdat hun stam op -d eindigt.",
        "solutionSteps": ["Lopen → stam = loop (geen d) → loopt", "Vinden → stam = vind (d) → vindt", "Worden → stam = word (d) → wordt", "Houden → stam = houd (d) → houdt"],
        "distractorExplanations": {
          "0": "'Vindt' heeft wél -dt: stam 'vind' eindigt op -d.",
          "1": "'Wordt' heeft wél -dt: stam 'word' eindigt op -d.",
          "2": "'Houdt' heeft wél -dt: stam 'houd' eindigt op -d.",
          "3": "Goed! 'Loopt' heeft geen -dt, want de stam 'loop' eindigt niet op -d."
        }
      }
    },
    {
      "id": "SPR-WEET-DT-005",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in: 'Hij ... (vinden) het leuk.' Typ het woord.",
      "correctAnswer": "vindt",
      "data": {
        "acceptedAnswers": ["vindt"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Vinden → hij vindt", "content": "Bij 'hij/zij/het' gebruik je de stam + t. De stam van 'vinden' is 'vind'. Omdat de stam al op -d eindigt, krijg je -dt: hij vindt. Dit is geen dt-fout — het is de gewone regel!", "icon": "lightbulb" } }
      ],
      "conceptId": "dt_vindt_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij 'hij' gebruik je de stam + t. De stam van 'vinden' is 'vind'. Omdat de stam al eindigt op -d, krijg je -dt wanneer je de -t toevoegt: hij vindt. Dit is de gewone regel voor werkwoorden waarvan de stam op -d eindigt. Andere voorbeelden: hij wordt (stam: word), zij houdt (stam: houd).",
        "solutionSteps": ["Infinitief: vinden", "Stam bepalen: vind (streep -en eraf)", "Bij 'hij': stam + t = vind + t = vindt", "Check: de -d hoort bij de stam, de -t is de uitgang"]
      }
    },
    {
      "id": "SPR-WEET-DT-006",
      "familyId": "SPR-WEET-DT",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_dt_woorden",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst. Tik op een fout woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Mijn vader rijd elke dag naar zijn werk. Hij vind het fijn om vroeg te beginnen. Soms houd hij pauze bij een tankstation.",
        "errors": [
          { "word": "rijd", "position": 2, "correction": "rijdt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (rijdt)" },
          { "word": "vind", "position": 9, "correction": "vindt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (vindt)" },
          { "word": "houd", "position": 17, "correction": "houdt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (houdt)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De dt-regel bij hij/zij/het",
            "content": "Bij hij, zij of het gebruik je in de tegenwoordige tijd de stam + t. Als de stam al op een -d eindigt (zoals bij rijden, vinden, houden), krijg je dus -dt: hij rijdt, hij vindt, hij houdt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "dt_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij 'hij' of 'mijn vader' gebruik je in de tegenwoordige tijd altijd de stam + t. Omdat de stam van rijden, vinden en houden al op een -d eindigt, krijg je -dt: rijdt, vindt, houdt.",
        "solutionSteps": [
          "Mijn vader (hij) + rijden = rijdt",
          "Hij + vinden = vindt",
          "Hij + houden = houdt"
        ]
      }
    }
  ]
}